import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import CallerIdIcon from '@mui/icons-material/CallMade';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import IncomingCallIcon from '@mui/icons-material/CallReceived';
import AccountIcon from '@mui/icons-material/Person';
import AccountCircle from '@mui/icons-material/AccountCircle';
import GeneralIcon from '@mui/icons-material/Settings';
import UsageIcon from '@mui/icons-material/ShowChart';
import MobileIcon from '@mui/icons-material/Smartphone';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import QueueIcon from '@mui/icons-material/People';
import CalendarIcon from '@mui/icons-material/Today';
import VoicemailIcon from '@mui/icons-material/Voicemail';
import VideoIcon from '@mui/icons-material/Videocam';
import PhoneIcon from '@mui/icons-material/Phone';
import ProfileIcon from '@mui/icons-material/Tonality';
import NavigateIcon from '@mui/icons-material/OpenInNew';
import CheckCircle from '@mui/icons-material/CheckCircle';
import LinkIcon from '@mui/icons-material/Link';
import MissedIcon from '@mui/icons-material/CallMissed';
import HistoryIcon from '@mui/icons-material/History';
import ChatIcon from '@mui/icons-material/Chat';
import PublicIcon from '@mui/icons-material/MeetingRoom';
import EditIcon from '@mui/icons-material/Edit';
import SharedContactIcon from '@mui/icons-material/CloudQueue';
import Attachment from '@mui/icons-material/AttachFile';
import CommunicationTextsms from '@mui/icons-material/Textsms';
import ContentSend from '@mui/icons-material/Send';
import EmojiIcon from '@mui/icons-material/InsertEmoticon';
import MailIcon from '@mui/icons-material/Mail';
import Call from '@mui/icons-material/Call';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Stop from '@mui/icons-material/Stop';
import PlayArrow from '@mui/icons-material/PlayArrow';
import GetApp from '@mui/icons-material/GetApp';
import Report from '@mui/icons-material/Report';
import ContactPermIcon from '@mui/icons-material/PermContactCalendar';
import SettingsPhone from '@mui/icons-material/SettingsPhone';
import Wallboard from '@mui/icons-material/Dashboard';
import Message from '@mui/icons-material/Message';
import Image from '@mui/icons-material/Image';
import Movie from '@mui/icons-material/Movie';
import File from '@mui/icons-material/InsertDriveFile';
import Done from '@mui/icons-material/Done';
import InfoIcon from '@mui/icons-material/Info';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MoreVert from '@mui/icons-material/MoreVert';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import Archive from '@mui/icons-material/Archive';
import Add from '@mui/icons-material/Add';
import ArrowDown from '@mui/icons-material/ArrowDropDown';
import PauseIcon from '@mui/icons-material/Pause';
import PauseCircleOutline from '@mui/icons-material/PauseCircleOutline';
import People from '@mui/icons-material/People';
import PersonAdd from '@mui/icons-material/PersonAdd';
import TuneIcon from '@mui/icons-material/Tune';
import VideocamOff from '@mui/icons-material/VideocamOff';
import MicOff from '@mui/icons-material/MicOff';
import Mic from '@mui/icons-material/Mic';
import ScreenShare from '@mui/icons-material/ScreenShare';
import Fullscreen from '@mui/icons-material/Fullscreen';
import FullscreenExit from '@mui/icons-material/FullscreenExit';
import Minimize from '@mui/icons-material/Minimize';
import PictureInPictureAlt from '@mui/icons-material/PictureInPictureAlt';
import Crop32 from '@mui/icons-material/Crop32';
import ReportProblem from '@mui/icons-material/ReportProblem';
import CallToAction from '@mui/icons-material/CallToAction';
import SearchIcon from '@mui/icons-material/Search';
import SupervisorIcon from '@mui/icons-material/RemoveRedEye';
import LaunchIcon from '@mui/icons-material/Launch';
import CallEnd from '@mui/icons-material/CallEnd';
import DialPad from '@mui/icons-material/Dialpad';
import Loop from '@mui/icons-material/Loop';
import Close from '@mui/icons-material/Close';
import Group from '@mui/icons-material/Group';
import ToggleCallIcon from '@mui/icons-material/Autorenew';
import SwapCalls from '@mui/icons-material/SwapCalls';
import NotInterested from '@mui/icons-material/NotInterested';
import Hearing from '@mui/icons-material/Hearing';
import PhoneInTalk from '@mui/icons-material/PhoneInTalk';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import CallMergeIcon from '@mui/icons-material/CallMerge';
import HourglassFull from '@mui/icons-material/HourglassFull';
import RingVolume from '@mui/icons-material/RingVolume';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import HeadsetIcon from '@mui/icons-material/HeadsetMic';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import Timer from '@mui/icons-material/Timer';
import StarBorder from '@mui/icons-material/StarBorder';
import ContactsIcon from '@mui/icons-material/Contacts';
import StarIcon from '@mui/icons-material/Star';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SubjectIcon from '@mui/icons-material/Subject';
import ReplayIcon from '@mui/icons-material/Replay';
import Flow from 'flow';
import WidgetIcon from 'flow/components/icons/WidgetIcon';
import CallsIcon from 'flow/components/icons/RecordingIcon';
import CopyIcon from 'flow/components/icons/CopyIcon';
import LookUpIcon from 'flow/components/icons/LookUpIcon';
import LogOutIcon from 'flow/components/icons/LogOutIcon';
import PostIcon from 'flow/components/icons/PostIcon';
import BankidIcon from 'flow/components/icons/BankidIcon';
import IvrIcon from 'flow/components/icons/IvrIcon';
import RightPanelIcon from 'flow/components/icons/RightPanelIcon';
import RightPanelInvertedIcon from 'flow/components/icons/RightPanelInvertedIcon';
import FullscreenInvertedIcon from 'flow/components/icons/FullscreenInvertedIcon';
import BottombarInvertedIcon from 'flow/components/icons/BottombarInvertedIcon';
import TransferCallIcon from 'flow/components/icons/TransferCallIcon';
import Extension from '@mui/icons-material/Extension';
import TelavoxIcon from 'flow/components/icons/TelavoxIcon';
import OmniQueueIcon from 'flow/components/icons/OmniQueueIcon';
import OmniQueueInvertedIcon from 'flow/components/icons/OmniQueueInvertedIcon';
import PercentIcon from 'flow/components/icons/PercentIcon';
import AvgIcon from 'flow/components/icons/AvgIcon';
import QuickReplyIcon from 'flow/components/icons/QuickReplyIcon';
import SupportAgentIcon from 'flow/components/icons/SupportAgentIcon';
import AssignToMe from 'flow/components/icons/AssignToUserIcon';
import AssignToOther from 'flow/components/icons/AssignToOtherIcon';
import PendingIcon from 'flow/components/icons/PendingIcon';
import { jsx as _jsx } from "react/jsx-runtime";
var iconComponents = {
  pending_icon: PendingIcon,
  assign_to_other: AssignToOther,
  assign_to_me: AssignToMe,
  replay: ReplayIcon,
  avg: AvgIcon,
  percent: PercentIcon,
  star: StarIcon,
  account: AccountIcon,
  accountCircle: AccountCircle,
  calendar: CalendarIcon,
  callerid: CallerIdIcon,
  calls: CallsIcon,
  general: GeneralIcon,
  notifications: NotificationsIcon,
  notifications_active: NotificationsActiveIcon,
  phone: PhoneIcon,
  profiles: ProfileIcon,
  usage: UsageIcon,
  mobile: MobileIcon,
  video: VideoIcon,
  voicemail: VoicemailIcon,
  widget: WidgetIcon,
  queuelogin: QueueIcon,
  shared: SharedContactIcon,
  incoming: IncomingCallIcon,
  flow_admin: NavigateIcon,
  success: CheckCircle,
  link: LinkIcon,
  copy: CopyIcon,
  lookUp: LookUpIcon,
  logOut: LogOutIcon,
  missedCalls: MissedIcon,
  callHistory: HistoryIcon,
  chat: ChatIcon,
  "public": PublicIcon,
  invite: PersonAdd,
  edit: EditIcon,
  "delete": DeleteIcon,
  attachment: Attachment,
  message_post: PostIcon,
  sms: CommunicationTextsms,
  send_message: ContentSend,
  emoji: EmojiIcon,
  show_more: ChevronRight,
  email: MailIcon,
  call: Call,
  arrow_forward: ArrowForward,
  arrow_back: ArrowBack,
  stop: Stop,
  play_arrow: PlayArrow,
  get_app: GetApp,
  create_contact: ContactPermIcon,
  report: Report,
  softphone: SettingsPhone,
  wallboard: Wallboard,
  message: Message,
  image: Image,
  movie: Movie,
  file: File,
  bankid: BankidIcon,
  done: Done,
  info: InfoIcon,
  infoOutlinedIcon: InfoOutlinedIcon,
  more_vert: MoreVert,
  more_horiz: MoreHoriz,
  archive: Archive,
  add: Add,
  arrow_down: ArrowDown,
  pause: PauseIcon,
  pause_circle_outline: PauseCircleOutline,
  ivr: IvrIcon,
  chat_member: People,
  chat_member_add: PersonAdd,
  setting_menu: TuneIcon,
  launch: LaunchIcon,
  videocam_off: VideocamOff,
  mic_off: MicOff,
  mic: Mic,
  screen_share: ScreenShare,
  fullscreen: Fullscreen,
  fullscreen_exit: FullscreenExit,
  minimize: Minimize,
  picture_in_picture_alt: PictureInPictureAlt,
  crop_32: Crop32,
  call_end: CallEnd,
  dialpad: DialPad,
  loop: Loop,
  close: Close,
  group: Group,
  toggle_call: ToggleCallIcon,
  swap_calls: SwapCalls,
  report_problem: ReportProblem,
  call_to_action: CallToAction,
  right_panel: RightPanelIcon,
  search: SearchIcon,
  right_panel_inverted: RightPanelInvertedIcon,
  fullscreen_inverted: FullscreenInvertedIcon,
  bottombar_inverted: BottombarInvertedIcon,
  'not-interested': NotInterested,
  transfer_call: TransferCallIcon,
  hearing: Hearing,
  phone_in_talk: PhoneInTalk,
  extension: Extension,
  chevron_left: ChevronLeft,
  chevron_right: ChevronRight,
  telavox: TelavoxIcon,
  merge_call: CallMergeIcon,
  'omni-queue': OmniQueueIcon,
  'omni-queue-inverted': OmniQueueInvertedIcon,
  hour_glass_full: HourglassFull,
  ring_volume: RingVolume,
  radio_button_unchecked: RadioButtonUnchecked,
  headset: HeadsetIcon,
  timelapse: TimelapseIcon,
  supervisor: SupervisorIcon,
  timer: Timer,
  favorite_outline: StarBorder,
  contacts: ContactsIcon,
  assignment: AssignmentIcon,
  assignee: AssignmentIndIcon,
  assignmentComplete: AssignmentTurnedInIcon,
  supervisorCircle: SupervisedUserCircleIcon,
  SubdirectoryArrowRight: SubdirectoryArrowRightIcon,
  description: DescriptionOutlinedIcon,
  subject: SubjectIcon,
  quick_response: QuickReplyIcon,
  support_agent: SupportAgentIcon
};
export var availableIconsList = Object.keys(iconComponents);
var FlowIcon = function FlowIcon(_ref) {
  var uniqueId = _ref.uniqueId,
    _ref$classes = _ref.classes,
    classes = _ref$classes === void 0 ? {} : _ref$classes,
    freeSize = _ref.freeSize;
  var Icon = iconComponents[uniqueId];
  var props = {
    className: classes.icon
  };
  if (freeSize) {
    props = _objectSpread(_objectSpread({}, props), {}, {
      fontSize: 'inherit'
    });
  }
  return Icon ? /*#__PURE__*/_jsx(Icon, _objectSpread({}, props)) : null;
};
FlowIcon.propTypes = {
  classes: Flow.PropTypes.materialStyles,
  freeSize: PropTypes.bool,
  uniqueId: PropTypes.string
};
export default FlowIcon;